import React from 'react';
import { observer } from 'mobx-react-lite';
import { TradingEvents } from 'src/components/TradingEvents/TradingEvents';
import { Liabilities } from 'src/domains/sportsbook/trading/view/Liabilities/Liabilities';
import BetSearch from 'src/components/BetSearch';
import TagManagement from 'src/components/TagManagement';
import PaymentSearch from 'src/components/PaymentSearch';
import { CSVUpload } from 'src/components/CSVUpload/CSVUpload';
import { useAppStateContext } from 'src/AppState/AppState';
import { TradingPageContent } from 'src/layouts/TradingPage/TradingPage.style';
import { AutomationTrading } from 'src/components/AutomationTrading/AutomationTrading';
import { CSVUploadV2 } from 'src/domains/sportsbook/trading/view/csv-upload/CSVUploadV2';
import { PaymentSearchV2 } from 'src/domains/sportsbook/trading/view/payment-search/PaymentSearchV2';

export const TradingContent = observer(() => {
    const {
        configState: { config },
        routerBackoffice,
    } = useAppStateContext();
    const customerParams = routerBackoffice.getParametersString('global', 'tab') ?? 'events';

    const isV2Page = ['csv-uploadV2', 'payment-searchV2'].includes(customerParams);

    return (
        <TradingPageContent
            data-test-page-content={customerParams}
            isV2Page={isV2Page}
        >
            {customerParams === 'csv-uploadV2' && <CSVUploadV2 />}
            {customerParams === 'payment-searchV2' && <PaymentSearchV2 />}

            {customerParams === 'events' && <TradingEvents />}
            {customerParams === 'liabilities' && <Liabilities />}
            {customerParams === 'tags' && config.tagManagementTab && <TagManagement />}
            {customerParams === 'bet-search' && <BetSearch />}
            {customerParams === 'payment-search' && <PaymentSearch />}
            {customerParams === 'csv-upload' && <CSVUpload />}
            {customerParams === 'automation' && <AutomationTrading />}
        </TradingPageContent>
    );
});
